export default "__VITE_ASSET__CIZIbZvQ__"